// Modelos opcionais de rotina para o onboarding. Não atribuem responsáveis nem presumem
// gênero ou papéis: a distribuição é feita pelo próprio lar depois.
// weekdays: 0 = domingo ... 6 = sábado.

export const DEFAULT_AREAS = [
  { key: 'limpeza', name: 'Limpeza', icon: 'sparkles', color: '#2f6f62' },
  { key: 'compras', name: 'Compras', icon: 'shopping-cart', color: '#e0873a' },
  { key: 'alimentacao', name: 'Alimentação', icon: 'utensils', color: '#c2553f' },
  { key: 'roupas', name: 'Roupas', icon: 'shirt', color: '#5b6cc2' },
  { key: 'manutencao', name: 'Manutenção', icon: 'wrench', color: '#6b7478' },
  { key: 'contas', name: 'Contas', icon: 'receipt', color: '#8a5cc2' },
  { key: 'animais', name: 'Animais', icon: 'paw-print', color: '#b0823a' },
  { key: 'outros', name: 'Outros', icon: 'circle', color: '#8b9497' },
];

export const HOUSEHOLD_PROFILES = [
  { key: 'solo', label: 'Moro sozinho(a)', description: 'Rotina enxuta para uma pessoa.' },
  { key: 'couple', label: 'Casal', description: 'Duas pessoas dividindo a casa.' },
  { key: 'family', label: 'Família', description: 'Adultos e crianças ou outros dependentes.' },
  { key: 'shared', label: 'Casa compartilhada', description: 'Pessoas que dividem moradia e despesas.' },
];

export const ROUTINES = [
  {
    key: 'lixo',
    title: 'Levar o lixo para fora',
    area: 'limpeza',
    freq: 'weekly',
    weekdays: [1, 4],
    profiles: ['solo', 'couple', 'family', 'shared'],
  },
  {
    key: 'banheiro',
    title: 'Limpar o banheiro',
    area: 'limpeza',
    freq: 'weekly',
    weekdays: [6],
    profiles: ['solo', 'couple', 'family', 'shared'],
  },
  {
    key: 'cozinha',
    title: 'Limpeza geral da cozinha',
    area: 'limpeza',
    freq: 'weekly',
    weekdays: [3],
    profiles: ['couple', 'family', 'shared'],
  },
  {
    key: 'louca',
    title: 'Lavar a louça',
    area: 'limpeza',
    freq: 'daily',
    profiles: ['couple', 'family', 'shared'],
  },
  {
    key: 'aspirar',
    title: 'Aspirar ou varrer a casa',
    area: 'limpeza',
    freq: 'weekly',
    weekdays: [6],
    profiles: ['solo', 'couple', 'family', 'shared'],
  },
  {
    key: 'roupa',
    title: 'Lavar roupas',
    area: 'roupas',
    freq: 'weekly',
    weekdays: [0],
    profiles: ['solo', 'couple', 'family'],
  },
  {
    key: 'roupa-cama',
    title: 'Trocar a roupa de cama',
    area: 'roupas',
    freq: 'weekly',
    interval: 2,
    weekdays: [0],
    profiles: ['solo', 'couple', 'family'],
  },
  {
    key: 'mercado',
    title: 'Revisar a lista e fazer mercado',
    area: 'compras',
    freq: 'weekly',
    weekdays: [5],
    profiles: ['solo', 'couple', 'family', 'shared'],
  },
  {
    key: 'cardapio',
    title: 'Planejar as refeições da semana',
    area: 'alimentacao',
    freq: 'weekly',
    weekdays: [0],
    profiles: ['couple', 'family'],
  },
  {
    key: 'geladeira',
    title: 'Conferir validade na geladeira',
    area: 'alimentacao',
    freq: 'weekly',
    weekdays: [4],
    profiles: ['solo', 'couple', 'family', 'shared'],
  },
  {
    key: 'contas-mes',
    title: 'Conferir contas do mês',
    area: 'contas',
    freq: 'monthly',
    monthDay: 1,
    profiles: ['solo', 'couple', 'family', 'shared'],
  },
  {
    key: 'dividir-contas',
    title: 'Acertar a divisão das despesas',
    area: 'contas',
    freq: 'monthly',
    monthDay: 5,
    profiles: ['shared'],
  },
  {
    key: 'plantas',
    title: 'Regar as plantas',
    area: 'outros',
    freq: 'weekly',
    weekdays: [2, 5],
    profiles: ['solo', 'couple', 'family'],
  },
  { key: 'pet-comida', title: 'Repor água e ração do pet', area: 'animais', freq: 'daily', profiles: [] },
  {
    key: 'filtro',
    title: 'Trocar o refil do filtro de água',
    area: 'manutencao',
    freq: 'monthly',
    interval: 6,
    monthDay: 10,
    profiles: [],
  },
];

export function suggestedRoutines(profile) {
  return ROUTINES.map((r) => ({ ...r, recommended: r.profiles.includes(profile) }));
}
